import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { StockLine } from '../../_models/stockLine';
import { OrderHeader } from '../../_models/orderHeader';
import { OrderLine } from '../../_models/orderLine';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

import * as _ from "lodash";

@Component({
  selector: 'app-create-returns',
  templateUrl: './create-returns.component.html',
  styleUrls: ['./create-returns.component.css']
})
export class CreateReturnsComponent implements OnInit {

  reasonList: any = [];
  headerDetails: OrderHeader = {};
  oderLines: OrderLine[] = [];
  //returnQuantity : number;
  errorMessage: string;
  statusText1: string;
  statusText2: string;
  reason: string;
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, public user: User, private api: ApiIntegration, private route: ActivatedRoute, private router: Router) {
    this.g.page = "Return Order";
    this.api.getValues("1", "ACCOUNT_OWNER", this.user.accountOwnerId, "REASON").subscribe((data: any) => { this.reasonList = data.tripleSetConfigDTOS; }, err => { console.log(err); });
    this.api.getStockTransferDetailsId(this.route.snapshot.params['id'], "1").subscribe((data: OrderHeader) => {
      this.headerDetails = data;
      this.oderLines = _.cloneDeep(this.headerDetails.lines);
    }, err => { console.log(err); });
  }
  ngOnInit() {
  }
  typeReturnedQuantity() {
    this.statusText2 = "";
    for (let ol of this.oderLines)
      if (ol.returnQuantity == '' || ol.returnQuantity === null || ol.returnQuantity === undefined || ol.returnQuantity === 'undefined') {
        this.statusText2 = 'Please Enter returnQuantity ';
      }
  }
  submitReturn() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    if (this.reason == '' || this.reason === null || this.reason === undefined || this.reason === 'undefined') {
      this.statusText1 = 'Please select Reason';
    }
    for (let ol of this.oderLines)
      if (ol.returnQuantity == '' || ol.returnQuantity === null || ol.returnQuantity === undefined || ol.returnQuantity === 'undefined') {
        this.statusText2 = 'Please enter return quantity ';
      }
    if (this.statusText1 != "" || this.statusText2 != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createReturns',
      {
        "accountOwnerId": this.user.accountOwnerId,
        "orderHeaderId": this.route.snapshot.params['id'],
        "orderStatus": "RETURN",
        "organizationId": 1,
        "orderLines": this.oderLines,
        "returnReason": this.reason
      },

      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Submit', 'Return Successfully');

          this.router.navigate(['/admin/returns']);
        }
        else if (data['code'] == 400) {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }
}
